export function TermsPage() {
  return (
    <div
      style={{
        minHeight: '100vh',
        minHeight: '100dvh',
        background: 'linear-gradient(155deg, #07070d 0%, #0b0b16 35%, #080812 100%)',
        fontFamily: '"DM Sans", sans-serif',
        color: '#e8e4dc',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        position: 'relative',
        overflowX: 'hidden',
        padding: 'clamp(24px, 5vh, 40px) 24px',
      }}
    >
      {/* Ambient orbs */}
      <div
        style={{
          position: 'fixed',
          top: '15%',
          left: '8%',
          width: 500,
          height: 500,
          background: 'radial-gradient(circle, rgba(255,107,43,.025) 0%, transparent 60%)',
          pointerEvents: 'none',
          animation: 'drift 25s ease-in-out infinite',
        }}
      />
      <div
        style={{
          position: 'fixed',
          bottom: '10%',
          right: '5%',
          width: 400,
          height: 400,
          background: 'radial-gradient(circle, rgba(78,205,196,.02) 0%, transparent 60%)',
          pointerEvents: 'none',
          animation: 'drift2 30s ease-in-out infinite',
        }}
      />

      <div style={{ maxWidth: 600, width: '100%', zIndex: 1 }}>
        <a
          href="/"
          style={{
            fontFamily: '"Space Mono", monospace',
            fontSize: 12,
            color: '#555',
            textDecoration: 'none',
            letterSpacing: 1,
          }}
        >
          &larr; back
        </a>

        <h1
          style={{
            fontFamily: '"Space Mono", monospace',
            fontSize: 'clamp(20px, 4vw, 28px)',
            fontWeight: 700,
            letterSpacing: 2,
            margin: '32px 0 8px',
          }}
        >
          terms of service
        </h1>

        <p style={{ fontSize: 12, color: '#555', margin: '0 0 32px' }}>
          Last updated: February 2, 2025
        </p>

        <div style={{ lineHeight: 1.8, color: '#aaa', fontSize: 14 }}>
          <section style={{ marginBottom: 28 }}>
            <h2 style={{ fontSize: 15, color: '#e8e4dc', fontWeight: 600, marginBottom: 8 }}>Provider</h2>
            <p style={{ margin: 0 }}>
              Pulse is operated by Left Join Studio, Inc.
            </p>
          </section>

          <section style={{ marginBottom: 28 }}>
            <h2 style={{ fontSize: 15, color: '#e8e4dc', fontWeight: 600, marginBottom: 8 }}>The service</h2>
            <p style={{ margin: 0 }}>
              Pulse is a real-time, ephemeral chat tool. Messages are not stored and fade
              automatically. There is no message history, no scrollback, and no persistence.
              The basic service is free to use.
            </p>
          </section>

          <section style={{ marginBottom: 28 }}>
            <h2 style={{ fontSize: 15, color: '#e8e4dc', fontWeight: 600, marginBottom: 8 }}>No warranty</h2>
            <p style={{ margin: 0 }}>
              The service is provided "AS IS" and "AS AVAILABLE" without warranty of any kind,
              express or implied, including but not limited to the warranties of merchantability,
              fitness for a particular purpose, and noninfringement. We do not guarantee uptime,
              availability, or that the service will be error-free.
            </p>
          </section>

          <section style={{ marginBottom: 28 }}>
            <h2 style={{ fontSize: 15, color: '#e8e4dc', fontWeight: 600, marginBottom: 8 }}>Future pricing</h2>
            <p style={{ margin: 0 }}>
              We reserve the right to introduce paid features or charge for services in the future.
              Any pricing changes will be communicated in advance. Free-tier access may be modified
              or limited at our discretion.
            </p>
          </section>

          <section style={{ marginBottom: 28 }}>
            <h2 style={{ fontSize: 15, color: '#e8e4dc', fontWeight: 600, marginBottom: 8 }}>User conduct</h2>
            <p style={{ margin: 0 }}>
              You are responsible for the content you transmit through the service. Do not use
              Pulse for illegal activity, harassment, or to transmit harmful content. We reserve
              the right to terminate access for any reason.
            </p>
          </section>

          <section style={{ marginBottom: 28 }}>
            <h2 style={{ fontSize: 15, color: '#e8e4dc', fontWeight: 600, marginBottom: 8 }}>Limitation of liability</h2>
            <p style={{ margin: 0 }}>
              In no event shall Left Join Studio, Inc. be liable for any indirect, incidental,
              special, consequential, or punitive damages, including without limitation loss of
              profits, data, or goodwill, arising out of or in connection with your use of the service.
            </p>
          </section>

          <section style={{ marginBottom: 28 }}>
            <h2 style={{ fontSize: 15, color: '#e8e4dc', fontWeight: 600, marginBottom: 8 }}>Changes</h2>
            <p style={{ margin: 0 }}>
              We may update these terms at any time. Continued use of the service constitutes
              acceptance of updated terms.
            </p>
          </section>

          <p style={{ margin: '32px 0 0', color: '#555', fontSize: 12 }}>
            See also: <a href="/privacy" style={{ color: '#ff6b2b', textDecoration: 'none' }}>privacy policy</a> · <a href="/credits" style={{ color: '#ff6b2b', textDecoration: 'none' }}>credits</a>
          </p>
        </div>
      </div>
    </div>
  );
}
